import { api } from '../../services';

/**
 * Creates the async data fetchers for the behavioral context.
 *
 * No longer a hook — receives its dependencies as plain arguments,
 * making it easier to test and reason about.
 */
export const createBehavioralFetchers = ({
    sidebarCartData,
    storeLocation,
    setFullPageLoader,
    acceptedTermUse,
    acceptedExamsUseTerms,
}) => {
    /**
     * Fetches product data when the user adds a product to the cart
     * from outside the product page.
     *
     * Returns a partial sidebarCartData object on success, or {} on failure.
     */
    const productDataFetcher = async (dataSet) => {
        setFullPageLoader(true);

        try {
            const url      = sidebarCartData.url || dataSet.url;
            const regionId = storeLocation.id;

            const response = await api.get(`/v1/cms/view?url=${url}&regionId=${regionId}`);

            const hasMatchingWarehouse = response.data.variants.some(item =>
                item.name.toLowerCase().includes(
                    sidebarCartData.lastWarehouseAdded.data.label.toLowerCase()
                )
            );

            const hasAcceptedTerms = acceptedTermUse || acceptedExamsUseTerms;
            const openSameWarehouseModal = hasMatchingWarehouse && hasAcceptedTerms;

            return {
                isOpen: !openSameWarehouseModal,
                isSameWarehouseModalOpen: openSameWarehouseModal,
                url: '',
                newProductData: {
                    selectedAmount:             1,
                    productData:                response.data,
                    productCategoryServiceType: response.data.product?.categoryServiceType,
                },
            };
        } catch (e) {
            console.error('Error while fetching product data:', e);
            return {};
        } finally {
            setFullPageLoader(false);
        }
    };

    /**
     * Fetches the self-service attendance modal content.
     *
     * Returns the response data directly on success, or null on failure —
     * consistent contract in both cases.
     */
    const selfServiceAttendanceModalDataFetcher = async () => {
        setFullPageLoader(true);

        try {
            const response = await api.get('/v1/tour');
            return response.data ?? null;
        } catch (e) {
            console.error('Error while fetching self-service modal data:', e);
            return null;
        } finally {
            setFullPageLoader(false);
        }
    };

    return {
        productDataFetcher,
        selfServiceAttendanceModalDataFetcher,
    };
};
